import { Subject, interval } from 'rxjs'
import { filter, map, switchMap, take, timeout } from 'rxjs/operators'
import { SimulationRepository } from '@/models/Simulation/SimulationRepository'
import { Phases } from '@/models/Simulation/Constants'

export class SimulationSubjectBuilder {
  timeout = 1000 * 60 // 1分
  interval = 1000 // 1秒

  static createBuilder() {
    return new SimulationSubjectBuilder()
  }

  addTimeout(timeout) {
    this.timeout = timeout
    return this
  }

  addInterval(interval) {
    this.interval = interval
    return this
  }

  build() {
    return new Subject().pipe(
      switchMap(conditionHash =>
        interval(this.interval).pipe(
          switchMap(() =>
            SimulationRepository.getByConditionHash(conditionHash),
          ),
          filter(res => this.isCompleted(res) || this.isFailed(res)),
          take(1),
          map(res => {
            if (this.isFailed(res)) {
              throw new Error()
            }
            return res
          }),
          timeout(this.timeout),
        ),
      ),
    )
  }

  isFailed(res) {
    return (
      res.item.phase === Phases.FAILED || res.item.phase === Phases.REJECTED
    )
  }

  isCompleted(res) {
    return (
      res.item.phase === Phases.CACHED || res.item.phase === Phases.COMPLETED
    )
  }
}
